import BlackRock from "./RandomArt-NFT/BlackRock.jpg";
import Blend from "./RandomArt-NFT/Blend.jpg";
import Ceasar from "./RandomArt-NFT/Ceasar.jpg";
import Emoboy from "./RandomArt-NFT/Emoboy.png";
import Hidden from "./RandomArt-NFT/Hidden.jpg";
import InMyHead from "./RandomArt-NFT/InMyHead.png";
import Lefou from "./RandomArt-NFT/Lefou.jpg";
import Lloys from "./RandomArt-NFT/Lloys.jpg";
import Mansa from "./RandomArt-NFT/Mansa.jpg";
import MetaBorg from "./RandomArt-NFT/MetaBorg.jpg";
import ModelPose from "./RandomArt-NFT/Modelpose.png";
import Moet from "./RandomArt-NFT/Moet.png";
import MoneyDrown from "./RandomArt-NFT/MoneyDrown.png";
import Paraphase from "./RandomArt-NFT/PARAPHASE.jpg";
import SkullTears from "./RandomArt-NFT/SkullTears.png";
import Tears from "./RandomArt-NFT/Tears.png";
import World from "./RandomArt-NFT/World.jpg";
import Wrapped from "./RandomArt-NFT/Wrapped.jpg";
import Artist from "./RandomArt-NFT/avatar.png";
import Drake from "../CelebrityArt/Celebrity-NFT/Drake.png";
import Steph from "../BasketballArt/Basketball-NFT/Steph.jpg";
const items = [
  {
    id: 1,
    title: "BlackRock",
    artist: "Femi",
    artistImage: Artist,
    image: BlackRock,
    info: "Digital art of Black Rock from our RandomArt collection",
    cover: true,
    center: false,
    price: "0.2ETH",
    collection: "RandomArt Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Player Collection", pic: Steph },
      { id: 2, name: "Celebrity Collection", pic: Drake },
      { id: 3, name: "RandomArt Collection", pic: Paraphase },
    ],
    artistStory:
      "Femi a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. Femi has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Femis Works via his social media pages to know more about him ",
  },
  {
    id: 2,
    title: "Blend",
    artist: "Femi",
    artistImage: Artist,
    image: Blend,
    info: "Digital art of Blend from our RandomArt collection",
    cover: true,
    center: false,
    price: "0.2ETH",
    collection: "RandomArt Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Player Collection", pic: Steph },
      { id: 2, name: "Celebrity Collection", pic: Drake },
      { id: 3, name: "RandomArt Collection", pic: Paraphase },
    ],
    artistStory:
      "Femi a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. Femi has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Femis Works via his social media pages to know more about him ",
  },
  {
    id: 3,
    title: "Hidden",
    artist: "Femi",
    artistImage: Artist,
    image: Hidden,
    info: "Digital art of Hidden from our RandomArt collection",
    cover: true,
    center: true,
    price: "0.2ETH",
    collection: "RandomArt Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Player Collection", pic: Steph },
      { id: 2, name: "Celebrity Collection", pic: Drake },
      { id: 3, name: "RandomArt Collection", pic: Paraphase },
    ],
    artistStory:
      "Femi a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. Femi has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Femis Works via his social media pages to know more about him ",
  },
  {
    id: 4,
    title: "Inmyhead",
    artist: "Femi",
    artistImage: Artist,
    image: InMyHead,
    info: "Digital art of InMyHead from our RandomArt collection",
    cover: true,
    center: false,
    price: "0.2ETH",
    collection: "RandomArt Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Player Collection", pic: Steph },
      { id: 2, name: "Celebrity Collection", pic: Drake },
      { id: 3, name: "RandomArt Collection", pic: Paraphase },
    ],
    artistStory:
      "Femi a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. Femi has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Femis Works via his social media pages to know more about him ",
  },
  {
    id: 5,
    title: "Lefou",
    artist: "Femi",
    artistImage: Artist,
    image: Lefou,
    info: "Digital art of Lefou from our RandomArt collection",
    cover: true,
    center: false,
    price: "0.2ETH",
    collection: "RandomArt Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Player Collection", pic: Steph },
      { id: 2, name: "Celebrity Collection", pic: Drake },
      { id: 3, name: "RandomArt Collection", pic: Paraphase },
    ],
    artistStory:
      "Femi a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. Femi has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Femis Works via his social media pages to know more about him ",
  },
  {
    id: 6,
    title: "Lloys",
    artist: "Femi",
    artistImage: Artist,
    image: Lloys,
    info: "Digital art of Lloys from our RandomArt collection",
    cover: true,
    center: true,
    price: "0.2ETH",
    collection: "RandomArt Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Player Collection", pic: Steph },
      { id: 2, name: "Celebrity Collection", pic: Drake },
      { id: 3, name: "RandomArt Collection", pic: Paraphase },
    ],
    artistStory:
      "Femi a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. Femi has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Femis Works via his social media pages to know more about him ",
  },
  {
    id: 7,
    title: "Mansa",
    artist: "Femi",
    artistImage: Artist,
    image: Mansa,
    info: "Digital art of Mansa from our RandomArt collection",
    cover: true,
    center: false,
    price: "0.2ETH",
    collection: "RandomArt Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Player Collection", pic: Steph },
      { id: 2, name: "Celebrity Collection", pic: Drake },
      { id: 3, name: "RandomArt Collection", pic: Paraphase },
    ],
    artistStory:
      "Femi a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. Femi has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Femis Works via his social media pages to know more about him ",
  },
  {
    id: 8,
    title: "MetaBorg",
    artist: "Femi",
    artistImage: Artist,
    image: MetaBorg,
    info: "Digital art of MetaBorg from our RandomArt collection",
    cover: true,
    center: false,
    price: "0.2ETH",
    collection: "RandomArt Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Player Collection", pic: Steph },
      { id: 2, name: "Celebrity Collection", pic: Drake },
      { id: 3, name: "RandomArt Collection", pic: Paraphase },
    ],
    artistStory:
      "Femi a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. Femi has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Femis Works via his social media pages to know more about him ",
  },
  {
    id: 9,
    title: "Modelpose",
    artist: "Femi",
    artistImage: Artist,
    image: ModelPose,
    info: "Digital art of ModelPose from our RandomArt collection",
    cover: true,
    center: true,
    price: "0.2ETH",
    collection: "RandomArt Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Player Collection", pic: Steph },
      { id: 2, name: "Celebrity Collection", pic: Drake },
      { id: 3, name: "RandomArt Collection", pic: Paraphase },
    ],
    artistStory:
      "Femi a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. Femi has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Femis Works via his social media pages to know more about him ",
  },
  {
    id: 10,
    title: "Moet",
    artist: "Femi",
    artistImage: Artist,
    image: Moet,
    info: "Digital art of Moet from our RandomArt collection",
    cover: true,
    center: false,
    price: "0.2ETH",
    collection: "RandomArt Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Player Collection", pic: Steph },
      { id: 2, name: "Celebrity Collection", pic: Drake },
      { id: 3, name: "RandomArt Collection", pic: Paraphase },
    ],
    artistStory:
      "Femi a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. Femi has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Femis Works via his social media pages to know more about him ",
  },
  {
    id: 11,
    title: "MoneyDrown",
    artist: "Femi",
    artistImage: Artist,
    image: MoneyDrown,
    info: "Digital art of MoneyDrown from our RandomArt collection",
    cover: true,
    center: false,
    price: "0.2ETH",
    collection: "RandomArt Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Player Collection", pic: Steph },
      { id: 2, name: "Celebrity Collection", pic: Drake },
      { id: 3, name: "RandomArt Collection", pic: Paraphase },
    ],
    artistStory:
      "Femi a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. Femi has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Femis Works via his social media pages to know more about him ",
  },
  {
    id: 12,
    title: "Paraphase",
    artist: "Femi",
    artistImage: Artist,
    image: Paraphase,
    info: "Digital art of ParaPhase from our RandomArt collection",
    cover: true,
    center: false,
    price: "0.2ETH",
    collection: "RandomArt Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Player Collection", pic: Steph },
      { id: 2, name: "Celebrity Collection", pic: Drake },
      { id: 3, name: "RandomArt Collection", pic: Paraphase },
    ],
    artistStory:
      "Femi a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. Femi has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Femis Works via his social media pages to know more about him ",
  },
  {
    id: 13,
    title: "SkullTears",
    artist: "Femi",
    artistImage: Artist,
    image: SkullTears,
    info: "Digital art of SkullTears from our RandomArt collection",
    cover: true,
    center: false,
    price: "0.2ETH",
    collection: "RandomArt Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Player Collection", pic: Steph },
      { id: 2, name: "Celebrity Collection", pic: Drake },
      { id: 3, name: "RandomArt Collection", pic: Paraphase },
    ],
    artistStory:
      "Femi a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. Femi has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Femis Works via his social media pages to know more about him ",
  },

  {
    id: 14,
    title: "Tears",
    artist: "Femi",
    artistImage: Artist,
    image: Tears,
    info: "Digital art of Tears from our RandomArt collection",
    cover: true,
    center: false,
    price: "0.2ETH",
    collection: "RandomArt Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Player Collection", pic: Steph },
      { id: 2, name: "Celebrity Collection", pic: Drake },
      { id: 3, name: "RandomArt Collection", pic: Paraphase },
    ],
    artistStory:
      "Femi a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. Femi has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Femis Works via his social media pages to know more about him ",
  },
  {
    id: 15,
    title: "World",
    artist: "Femi",
    artistImage: Artist,
    image: World,
    info: "Digital art of World from our RandomArt collection",
    cover: true,
    center: false,
    price: "0.2ETH",
    collection: "RandomArt Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Player Collection", pic: Steph },
      { id: 2, name: "Celebrity Collection", pic: Drake },
      { id: 3, name: "RandomArt Collection", pic: Paraphase },
    ],
    artistStory:
      "Femi a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. Femi has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Femis Works via his social media pages to know more about him ",
  },
  {
    id: 16,
    title: "Wrapped",
    artist: "Femi",
    artistImage: Artist,
    image: Wrapped,
    info: "Digital art of Wrapped  from our RandomArt collection",
    cover: true,
    center: false,
    price: "0.2ETH",
    collection: "RandomArt Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Player Collection", pic: Steph },
      { id: 2, name: "Celebrity Collection", pic: Drake },
      { id: 3, name: "RandomArt Collection", pic: Paraphase },
    ],
    artistStory:
      "Femi a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. Femi has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Femis Works via his social media pages to know more about him ",
  },
  {
    id: 17,
    title: "Emoboy",
    artist: "Femi",
    artistImage: Artist,
    image: Emoboy,
    info: "Digital art of Emoboy from our RandomArt collection",
    cover: true,
    center: false,
    price: "0.2ETH",
    collection: "RandomArt Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Player Collection", pic: Steph },
      { id: 2, name: "Celebrity Collection", pic: Drake },
      { id: 3, name: "RandomArt Collection", pic: Paraphase },
    ],
    artistStory:
      "Femi a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. Femi has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Femis Works via his social media pages to know more about him ",
  },
  {
    id: 18,
    title: "Ceasar",
    artist: "Femi",
    artistImage: Artist,
    image: Ceasar,
    info: "Digital art of Ceasar from our RandomArt collection",
    cover: true,
    center: false,
    price: "0.2ETH",
    collection: "RandomArt Collection",
    post: "Digital Creative Artist",
    collections: [
      { id: 1, name: "Player Collection", pic: Steph },
      { id: 2, name: "Celebrity Collection", pic: Drake },
      { id: 3, name: "RandomArt Collection", pic: Paraphase },
    ],
    artistStory:
      "Femi a talented artist born out of Nigeria from the trenches of Lagos sees art as a way to express his thoughts and tell stories from his minted pieces. Femi has been in the art business for more than a decade now and with the emergence of NFTs he plans on taking showing people and the world at large how talented he is with his pieces, follow Femis Works via his social media pages to know more about him ",
  },
];
export default items;
